import { getLiveLink, getTestLinks } from 'util/surveys';
import { Survey } from '../../../../types/domainModels';
import { useHasRole } from 'hooks/users';

import CopyToClipboard from 'components/common/CopyToClipboard';
import Hyperlink from '../../../common/Hyperlink';
import QRCodePopup from 'components/surveyEdit/QRCodePopup/QRCodePopup';

export const SurveyLinks = ({ survey }: { survey: Survey }) => {
  const isAdmin = useHasRole('admin');

  const { previewLink, testLink } = getTestLinks({ survey });
  const liveLink = getLiveLink({ isAdmin, survey });

  return (
    <div className="space-y-4">
      <h2 className="text-base font-semibold">Survey Links</h2>
      <div className="grid grid-cols-[150px_40px_40px] text-sm">
        <div className="truncate">
          <Hyperlink href={testLink}>Test Link</Hyperlink>
        </div>
        <CopyToClipboard text={testLink} />
        <QRCodePopup link={testLink} />
      </div>
      <div className="grid grid-cols-[150px_40px_40px] text-sm">
        <div className="truncate">
          <Hyperlink href={previewLink}>Preview Link</Hyperlink>
        </div>
        <CopyToClipboard text={previewLink} />
        <QRCodePopup link={previewLink} />
      </div>
      {liveLink && (
        <div className="grid grid-cols-[150px_40px_40px] text-sm">
          <div className="truncate">
            <Hyperlink href={liveLink}>Live Link</Hyperlink>
          </div>
          <CopyToClipboard text={liveLink} />
          <QRCodePopup link={liveLink} />
        </div>
      )}
    </div>
  );
};
